import { Box, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { handleConnectionDetailChange } from '../../../utils';

interface MySQLFieldsProps {
  isEditable: boolean;
  formValues: Record<string, string | string[]>;
  handleInputChange: (name: string, value: string) => void;
  onValidityChange: (isValid: boolean) => void;
}

// const MYSQL_HOSTNAME_REGEX = /^mysql\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
// const MYSQL_PORT_REGEX = /^[0-9]+$/;
// const MYSQL_DATABASE_NAME_REGEX = /^[a-zA-Z0-9_]+$/;
// const MYSQL_READ_ONLY_USERNAME_REGEX = /^[a-zA-Z0-9_]+$/;

const MySQLFields: React.FC<MySQLFieldsProps> = ({
  isEditable,
  formValues,
  handleInputChange,
  onValidityChange,
}) => {
  const connectionDetails = JSON.parse((formValues.connectionDetails as string) || '{}');

  const [isTouched, setIsTouched] = useState({
    hostname: false,
    port: false,
    databaseName: false,
    readOnlyUsername: false,
  });

  useEffect(() => {
    const isHostnameValid = !!connectionDetails.hostname;
    const isPortValid = !!connectionDetails.port;
    const isDatabaseNameValid = !!connectionDetails.databaseName;
    const isReadOnlyUsernameValid = !!connectionDetails.readOnlyUsername;

    const isAllValid =
      isHostnameValid && isPortValid && isDatabaseNameValid && isReadOnlyUsernameValid;
    onValidityChange?.(isAllValid);
  }, [
    connectionDetails.hostname,
    connectionDetails.port,
    connectionDetails.databaseName,
    connectionDetails.readOnlyUsername,
  ]);

  return (
    <>
      <TextField
        label="Hostname"
        placeholder="e.g. mysql.yourdomain.com"
        value={connectionDetails.hostname}
        error={!connectionDetails.hostname && isTouched.hostname}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            hostname: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('hostname', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Port"
        placeholder="e.g. 3306"
        value={connectionDetails.port}
        error={!connectionDetails.port && isTouched.port}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            port: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('port', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Database Name"
        placeholder="e.g. pvx_game_data"
        value={connectionDetails.databaseName}
        error={!connectionDetails.databaseName && isTouched.databaseName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            databaseName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange(
            'databaseName',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: '#6c6c6c',
          }}
        >
          Read-Only Credentials
        </Typography>
        <TextField
          label="User Name"
          placeholder="e.g. pvx_read_only_user"
          value={connectionDetails.readOnlyUsername}
          error={!connectionDetails.readOnlyUsername && isTouched.readOnlyUsername}
          onBlur={(e) => {
            setIsTouched((prev) => ({
              ...prev,
              readOnlyUsername: true,
            }));
          }}
          onChange={(e) =>
            handleConnectionDetailChange(
              'readOnlyUsername',
              e.target.value,
              formValues,
              handleInputChange,
            )
          }
          sx={{
            width: '100%',
          }}
          disabled={!isEditable}
        />
      </Box>
      <TextField
        label="Password"
        placeholder="e.g. password"
        value={connectionDetails.password}
        onChange={(e) =>
          handleConnectionDetailChange('password', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
    </>
  );
};

export default MySQLFields;
